import { Controller } from '@hotwired/stimulus'
import { formatEuro, formatEuroAmount, formatRate, parseEuro } from '../helpers/currency'

export default class extends Controller {
  static targets = ['amount', 'rate', 'amountOutput', 'fee', 'feeRate', 'total', 'error', 'submit', 'debitWarning']
  static values = { cap: Number, rate: Number, compact: Boolean, debitCap: Number }

  connect() {
    this.recompute()
  }

  recompute() {
    const amount = parseEuro(this.amountTarget.value)
    const rate = this.hasRateTarget ? parseFloat(this.rateTarget.value) || 0 : this.rateValue
    const fee = (amount * rate) / 100
    const total = amount + fee
    const formatAmount = this.compactValue ? formatEuroAmount : formatEuro

    if (this.hasAmountOutputTarget) this.amountOutputTarget.textContent = formatAmount(amount)
    if (this.hasFeeRateTarget) this.feeRateTarget.textContent = formatRate(rate)
    this.feeTarget.textContent = formatEuro(fee)
    this.totalTarget.textContent = formatAmount(total)

    this.#toggleCap(rate)
    this.#toggleDebitWarning(total)
  }

  #toggleCap(rate) {
    const overCap = this.hasCapValue && this.capValue > 0 && rate > this.capValue

    if (this.hasErrorTarget) this.errorTarget.classList.toggle('d-none', !overCap)
    if (this.hasSubmitTarget) this.submitTarget.disabled = overCap
  }

  // The SEPA debit ceiling is informative only: the investor keeps going and Audacia collects the
  // funds out of band.
  #toggleDebitWarning(total) {
    if (!this.hasDebitWarningTarget) return

    const overCap = this.hasDebitCapValue && this.debitCapValue > 0 && total > this.debitCapValue
    this.debitWarningTarget.classList.toggle('d-none', !overCap)
  }
}
